var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[(_vm.$slots.default)?_c('div',{ref:"contentRef",attrs:{"lnglat":_vm.lngLat}},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }